


document.querySelectorAll("img.hs-lazyload").forEach(img => {
  if (img.src.includes("data:image")) img.src = img.getAttribute("data-src")
})


jQuery(document).ready(function ($) {
  var owl = $("#story .owl-carousel").owlCarousel({
    nav: true,
    dots: false,
    loop: false,
    items: 1,
    center: false,
    autoplay: false,
    margin: 50,
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#featured .owl-carousel").owlCarousel({
    nav: true,
    dots: false,
    loop: false,
    items: 1,
    center: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
      },
      800: {
        items: 2,
      },
    },
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#hero .owl-carousel").owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    items: 1,
    center: true,
    autoplay: true,
    autoplayHoverPause: true,
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#features .owl-carousel").owlCarousel({
    nav: true,
    dots: false,
    loop: true,
    items: 1,
    center: false,
    autoplay: false,
    margin: 50,
  });

  $(".owl-dot").each((idx, node) => {
    node.setAttribute("aria-label", "Slider Navigation");
  });

  function renderNavi() {
    let txtH = $("#features .owl-item.active .slide .txt").outerHeight();
    let imgH = $("#features .owl-item.active .slide .img img").height();
    let where = txtH + imgH / 2;
    $("#features .owl-nav").css({ top: where });
  }

  $(window).resize(renderNavi);

  owl.on("resized.owl.carousel", function (event) {
    renderNavi();
  });

  owl.on("initialized.owl.carousel", function (event) {
    renderNavi();
  });

  owl.on("translated.owl.carousel", function (event) {
    renderNavi();
  });

  renderNavi();
});

jQuery(document).ready(function ($) {
  var owl = $("#promo .owl-carousel").owlCarousel({
    nav: true,
    dots: true,
    loop: false,
    items: 1,
    center: false,
    autoplay: false,
    margin: 50,
  });

  $(".owl-dot").each((idx, node) => {
    node.setAttribute("aria-label", "Slider Navigation");
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#promo .owl-carousel").owlCarousel({
    nav: true,
    dots: true,
    loop: false,
    items: 1,
    center: false,
    autoplay: false,
    margin: 50,
  });

  $(".owl-dot").each((idx, node) => {
    node.setAttribute("aria-label", "Slider Navigation");
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#reviews .owl-carousel").owlCarousel({
    nav: false,
    dots: false,
    loop: false,
    items: 1,
    center: false,
    autoplay: false,
    margin: 50,
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#clubs .owl-carousel").owlCarousel({
    nav: false,
    dots: false,
    loop: true,
    items: 4,
    center: false,
    autoplay: true,
    autoplayTimeout: 1000,
    autoplayHoverPause: true,
    margin: 50,
    autoWidth: true,
  });
});

jQuery(document).ready(function ($) {
  var owl = $("#clubs .owl-carousel").owlCarousel({
    nav: false,
    dots: false,
    loop: true,
    items: 4,
    center: false,
    autoplay: true,
    autoplayTimeout: 1000,
    autoplayHoverPause: true,
    margin: 50,
    autoWidth: true,
  });
  let ind, url;
      
      $('#quotes .quotes .quote').hide();
      $('#quotes .quotes .quote').eq(0).css({'display':'flex'});
      $('#quotes nav .img').eq(0).addClass('active');
  
      $('#quotes nav .img').on('click', function(){
          ind = $(this).index();
          $('#quotes nav .img').removeClass('active');
          $(this).addClass('active');
          $('#quotes .quotes .quote').hide();
          $('#quotes .quotes .quote').eq(ind).css({'display':'flex'});
      })
});

ratingSnippet("ruk_rating_snippet", {
  store: "themagic5-com",
  color: "#f47e27",
  linebreak: true,
  usePolaris: true,
  text: "Reviews",
  css: '@import url("https://fonts.googleapis.com/css?family=Montserrat"); .prodRevWidget * { font-family: Montserrat,sans-serif;}',
});


